import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, mergeProps as _mergeProps } from "vue"
import _imports_0 from '@/assets/finance/pay-account-01.png'
import _imports_1 from '@/assets/finance/pay-account-02.png'
import _imports_2 from '@/assets/finance/pay-alipay.png'
import _imports_3 from '@/assets/finance/pay-wechatpay.png'


const _hoisted_1 = { class: "routeTab" }
const _hoisted_2 = { class: "topUpView__ledger" }
const _hoisted_3 = { class: "group" }
const _hoisted_4 = { class: "part" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "part" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "part" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "subsidiary"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "controls" }
const _hoisted_13 = { style: {"font-size":"17px"} }
const _hoisted_14 = { class: "topUpView__squareRadio" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "22",
    style: {"margin-right":"10px"}
  })
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "银行汇款", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "25",
    alt: ""
  })
], -1)
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  width: "77"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "25"
  })
], -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  width: "97"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "25"
  })
], -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { class: "topUpView__topUpMoney" }
const _hoisted_26 = { class: "custom" }
const _hoisted_27 = {
  key: 1,
  class: "topUpView__submitBtnWrap"
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", null, "请您通过网银转账，或者自行到银行进行汇款，汇款账号如下：", -1)
const _hoisted_30 = { style: {"padding-left":"30px"} }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", null, "收款户名", -1)
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", null, "开户行", -1)
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", null, "支行名称", -1)
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", null, "收款账号", -1)
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", { class: "text-warning" }, " * 请务必使用对公银行账户进行汇款，汇款主体需与公司认证名称保持一致。 ", -1)
const _hoisted_40 = {
  key: 0,
  class: "financeTips"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_app_input_number = _resolveComponent("app-input-number")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_top_up_qrcode_modal = _resolveComponent("top-up-qrcode-modal")!
  const _component_dialog_qr_code = _resolveComponent("dialog-qr-code")!
  const _component_transform_log = _resolveComponent("transform-log")!
  const _component_all_company_blance = _resolveComponent("all-company-blance")!
  const _component_transfer_modal = _resolveComponent("transfer-modal")!
  const _component_recycle_modal = _resolveComponent("recycle-modal")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, _mergeProps(_ctx.$attrs, { class: "utils__pageContainer withRouteTab topUpView" }), {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, { to: { name: 'finance.top_up' } }, {
          default: _withCtx(() => [
            _createTextVNode("充值")
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, { to: { name: 'finance.top-up-record' } }, {
          default: _withCtx(() => [
            _createTextVNode("充值记录")
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, { to: { name: 'finance.freeze-record' } }, {
          default: _withCtx(() => [
            _createTextVNode("冻结记录")
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, { to: { name: 'finance.limit-reminder' } }, {
          default: _withCtx(() => [
            _createTextVNode("额度提醒")
          ]),
          _: 1
        }, 8, ["to"]),
        (_ctx.enterprise.cashbackStateStr !== 'credit')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'finance.withdraw-deposit' }
            }, {
              default: _withCtx(() => [
                _createTextVNode("提现")
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", {
              class: "font-DIN primary",
              innerHTML: _ctx.renderWithSub(_ctx.formatWithIntl(_ctx.financeDetail.totalBalance))
            }, null, 8, _hoisted_5),
            _createElementVNode("label", null, [
              _createTextVNode(" 企业账户余额 "),
              _createVNode(_component_a_tooltip, {
                placement: "top",
                title: _ctx.TIPS_LIST.TOTAL_BLANCE
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_app_icon, {
                    type: "question",
                    class: "tipIcon"
                  })
                ]),
                _: 1
              }, 8, ["title"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", {
              class: "font-DIN",
              innerHTML: _ctx.renderWithSub(_ctx.formatWithIntl(_ctx.financeDetail.availableAmount))
            }, null, 8, _hoisted_7),
            _createElementVNode("label", null, [
              _createTextVNode(" 可用余额 "),
              _createVNode(_component_a_tooltip, {
                placement: "top",
                title: _ctx.TIPS_LIST.AVAILABLE_AMOUNT
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_app_icon, {
                    type: "question",
                    class: "tipIcon"
                  })
                ]),
                _: 1
              }, 8, ["title"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", {
              class: "font-DIN",
              innerHTML: _ctx.renderWithSub(_ctx.formatWithIntl(_ctx.financeDetail.enterpriseFrozenAmount))
            }, null, 8, _hoisted_9),
            _createElementVNode("label", null, [
              _createTextVNode(" 冻结金额 "),
              _createVNode(_component_a_tooltip, {
                placement: "top",
                title: _ctx.TIPS_LIST.FROZEN_AMOUNT
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_app_icon, {
                    type: "question",
                    class: "tipIcon"
                  })
                ]),
                _: 1
              }, 8, ["title"])
            ])
          ])
        ]),
        (_ctx.hasSubsidiary)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("p", null, [
                _createTextVNode(" 分子公司账户余额 "),
                _createElementVNode("span", {
                  class: "amount font-DIN",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onViewAllCompanyBlance && _ctx.onViewAllCompanyBlance(...args))),
                  innerHTML: _ctx.renderWithSub(_ctx.formatWithIntl(_ctx.toLocalUnit(_ctx.financeDetail.childEnterpriseBalance || 0)))
                }, null, 8, _hoisted_11),
                _createTextVNode(" 元 ")
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _ctx.onTransfer
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("转账")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, { onClick: _ctx.onRecycle }, {
                  default: _withCtx(() => [
                    _createTextVNode("回收")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  type: "link",
                  onClick: _ctx.onViewTransformLog
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("转账记录")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_a_form, {
        class: "topUpView__form",
        model: _ctx.formData,
        rules: _ctx.rules,
        "label-col": { span: 2 },
        "wrapper-col": { span: 14 },
        onSubmit: _ctx.onSubmit
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, { label: "收款公司名称" }, {
            default: _withCtx(() => [
              _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.backInfo[0].companyName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "支付方式" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_14, [
                _createElementVNode("li", {
                  class: _normalizeClass({ 'cur': _ctx.formData.payType === 3 }),
                  style: _normalizeStyle(`flex: ${!_ctx.whetherThirdPartyRecharge ? 'none' : '1'}`),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePayType(3)))
                }, _hoisted_18, 6),
                (_ctx.whetherThirdPartyRecharge)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      class: _normalizeClass({ 'cur': _ctx.formData.payType === 2 }),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePayType(2)))
                    }, _hoisted_21, 2))
                  : _createCommentVNode("", true),
                (_ctx.whetherThirdPartyRecharge)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 1,
                      class: _normalizeClass({ 'cur': _ctx.formData.payType === 1 }),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePayType(1)))
                    }, _hoisted_24, 2))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          (_ctx.formData.payType !== 3)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 0,
                class: "topUpView__amount",
                label: "充值金额"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", {
                      class: _normalizeClass({cur: !_ctx.userCustom && _ctx.formData.selectAmount === 1000 }),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.userSelectMount(1000)))
                    }, "1000.00", 2),
                    _createElementVNode("div", {
                      class: _normalizeClass({cur: !_ctx.userCustom && _ctx.formData.selectAmount === 2000 }),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.userSelectMount(2000)))
                    }, "2000.00", 2),
                    _createElementVNode("div", {
                      class: _normalizeClass({cur: !_ctx.userCustom && _ctx.formData.selectAmount === 3000 }),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.userSelectMount(3000)))
                    }, "3000.00", 2),
                    _createElementVNode("div", {
                      class: _normalizeClass({cur: !_ctx.userCustom && _ctx.formData.selectAmount === 5000 }),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.userSelectMount(5000)))
                    }, "5000.00", 2),
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_app_input_number, {
                        value: _ctx.formData.userAmount,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.userAmount) = $event)),
                        style: {"width":"230px","height":"40px"},
                        placeholder: "输入金额",
                        onClick: _ctx.onFocusMoneyInput,
                        onBlur: _ctx.onBlurMoneyInput
                      }, null, 8, ["value", "onClick", "onBlur"]),
                      _createTextVNode(" 元 "),
                      _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.moneyInputError), 513), [
                        [_vShow, _ctx.moneyInputError]
                      ])
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.formData.payType !== 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  loading: _ctx.submitLoading,
                  onClick: _ctx.showQrcodeModel
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("充值")
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"]),
                (_ctx.serverError)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.serverError), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.formData.payType === 3)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 2,
                label: "收款信息"
              }, {
                default: _withCtx(() => [
                  _hoisted_29
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.formData.payType === 3)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 3,
                "wrapper-col": { span: 14, offset: 2 }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_30, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.backInfo, (item) => {
                      return (_openBlock(), _createElementBlock("table", {
                        key: item.id,
                        class: "topUpView__bankInfo"
                      }, [
                        _createElementVNode("tr", null, [
                          _hoisted_31,
                          _createElementVNode("td", null, [
                            _createTextVNode(_toDisplayString(item.companyName), 1),
                            _createElementVNode("a", {
                              class: "topUpView__copyLink",
                              onClick: _withModifiers(($event: any) => (_ctx.onCopyAccount(item.companyName)), ["prevent"])
                            }, null, 8, _hoisted_32)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_33,
                          _createElementVNode("td", null, [
                            _createTextVNode(_toDisplayString(item.backName) + " ", 1),
                            _createElementVNode("a", {
                              class: "topUpView__copyLink",
                              onClick: _withModifiers(($event: any) => (_ctx.onCopyAccount(item.backName)), ["prevent"])
                            }, null, 8, _hoisted_34)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_35,
                          _createElementVNode("td", null, [
                            _createTextVNode(_toDisplayString(item.branch) + " ", 1),
                            _createElementVNode("a", {
                              class: "topUpView__copyLink",
                              onClick: _withModifiers(($event: any) => (_ctx.onCopyAccount(item.branch)), ["prevent"])
                            }, null, 8, _hoisted_36)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_37,
                          _createElementVNode("td", null, [
                            _createTextVNode(_toDisplayString(item.backAccount) + " ", 1),
                            _createElementVNode("a", {
                              class: "topUpView__copyLink",
                              onClick: _withModifiers(($event: any) => (_ctx.onCopyAccount(item.backAccount)), ["prevent"])
                            }, null, 8, _hoisted_38)
                          ])
                        ])
                      ]))
                    }), 128)),
                    _hoisted_39
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model", "rules", "onSubmit"]),
      (_ctx.formData.payType === 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _createTextVNode(" 汇款须知: "),
            _hoisted_41,
            _createTextVNode(" 1、在汇款前请确认您已完成企业认证，且打款账号的户名与认证时营业执照企业名称一致; "),
            _hoisted_42,
            _createTextVNode(" 2、贵司在汇款1小时后，若企业账户未充值到账，请将贵公司名称、汇款人姓名、联系方式、汇款金额、汇款时间、汇款银行账号信息或汇款底单发送qfkf@newlink.com，我们收到信息将在第一时间为您解决。紧急联系电话: 17835419040; "),
            _hoisted_43,
            _createTextVNode(" 3、充值时间尽量选择在每天早9:00到22:00间，其他时间会有延迟到账风险 "),
            _hoisted_44
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_top_up_qrcode_modal, { ref: "modal" }, null, 512),
      _createVNode(_component_dialog_qr_code, {
        ref: "qrcode",
        onPayComplete: _ctx.onPayComplete
      }, null, 8, ["onPayComplete"]),
      _createVNode(_component_transform_log, { ref: "transformLogRef" }, null, 512),
      _createVNode(_component_all_company_blance, { ref: "allCompanyBlanceRef" }, null, 512),
      _createVNode(_component_transfer_modal, {
        ref: "transferModalRef",
        onComplete: _ctx.loadFinanceDetail
      }, null, 8, ["onComplete"]),
      _createVNode(_component_recycle_modal, {
        ref: "recycleModalRef",
        onComplete: _ctx.loadFinanceDetail
      }, null, 8, ["onComplete"])
    ]),
    _: 1
  }, 16))
}